module.exports = __webpack_public_path__ + "media/data_tables/sort_desc-8f88d990.png";